export default __webpack_public_path__ + "static/heroMobile-dc3dfdce61cfc75326c2cdde398d6488.png";